import "./copy.css"
const Copy = () => {
  return (
    <div class="geraisnet-bottom-container">
      <p>© 2026 Gerais Net – Todos os direitos reservados</p>
      <p>
        Desenvolvido com <i className="fas fa-heart"></i> para conectar você
      </p>
    </div>
  );
}; export default Copy;
